import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ResumeTailoringProvider } from '@/contexts/ResumeTailoringContext';
import { CustomLayout } from '@/components/ui/custom-layout';
import { PaywallGuard } from '@/components/PaywallGuard';
import { ResumeSelectionPage } from './ResumeSelectionPage';
import { JobInformationPage } from './JobInformationPage';
import { TailoringPreferencesPage } from './TailoringPreferencesPage';
import { ReviewGeneratePage } from './ReviewGeneratePage';
import { ResultsPage } from './ResultsPage';

export function ResumeTailoringRouter() {
  return (
    <ResumeTailoringProvider>
      <CustomLayout>
        <PaywallGuard feature="Resume Tailoring">
          <Routes>
            <Route path="/" element={<Navigate to="step/1" replace />} />
            <Route path="/step/1" element={<ResumeSelectionPage />} />
            <Route path="/step/2" element={<JobInformationPage />} />
            <Route path="/step/3" element={<TailoringPreferencesPage />} />
            <Route path="/step/4" element={<ReviewGeneratePage />} />
            <Route path="/step/5" element={<ResultsPage />} />
          </Routes>
        </PaywallGuard>
      </CustomLayout>
    </ResumeTailoringProvider>
  );
}